import AddingVisitor from './AddingVisitor';

export default AddingVisitor;
